export function listProjectCategory(params) {
    return window.axios.post("api/projectCategory/bmlist", params)
}

export function listProjectCategory1(params) {
    return window.axios.post("api/projectCategory/bmlist1", params)
}

export function bmlistCategory(params) {
    return window.axios.post("api/projectCategory/bmlist", params)
}

export function deleteProjectCategory(id) {
    return window.axios.post("api/projectCategory/delete", { id: id })
}

export function updateProjectCategory(params) {
    return window.axios.post("api/projectCategory/update", params)
}

export function addProjectCategory(params) {
    return window.axios.post("api/projectCategory/add", params)
}

export function getProjectCategory(id) {
    return window.axios.post("api/projectCategory/get", { id: id })
}

export function updateShowEnable(params) {
    return window.axios.post("api/projectCategory/updateShowEnable", params)
}


export function exportProjectCategory(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/projectCategory/export/excel", params, config)
}
export function exportProjectCategoryConfig() {
    return window.axios.post("api/projectCategory/exportConfig", {})
}
